:host {
  display: block;

  .not-clickable {
    pointer-events: none;
  }

  a {
    display: block;

    &:focus,
    &:focus-visible {
      @include state-focus-outline;
    }
  }

  picture img {
    display: block;
    width: var(--wink-logo-width, 100%);
    max-width: wink-rem(8);
    height: auto;
  }
}
